export default {
  customer: 1,
  "App\\Models\\Account": 2,
  "App\\Models\\Policy": 3,
  "App\\Models\\Damage": 4,
  "App\\Models\\Mortgage": 5,
  "App\\Models\\Customer\\Obligation": 8,
};
